import type { TournamentFragment } from '~/client/features/Tournaments/graphql/TournamentFragment.generated';
import TournamentActionButton from '~/client/features/Tournaments/shared/TournamentActionButton';
import PopoverLeaderboard from './PopoverLeaderboard';
import ShortLeaderboard from './ShortLeaderboard';

type Props = { tournament?: TournamentFragment };

const Leaderboard: FC<Props> = ({ tournament }) => {
  if (!tournament?.iAmOptedIn) {
    return (
      <div className="grid items-center gap-4 justify-self-end">
        <TournamentActionButton tournament={tournament} />
      </div>
    );
  }
  return (
    <div className="relative grid w-[11.25rem] items-center justify-items-center gap-0">
      <ShortLeaderboard tournament={tournament} />
      <PopoverLeaderboard tournament={tournament} />
    </div>
  );
};

export default Leaderboard;
